import React, { FC, ReactNode } from 'react';

import { Box, Center, Stack } from '@chakra-ui/react';

import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';

import { BorderedBox } from '../Box/BorderedBox';

interface Props {
  content: ReactNode;
  label: string;
  isLoading?: boolean;
}

export const FootprintBox: FC<Props> = props => {
  const { content, label, isLoading } = props;
  return (
    <BorderedBox w="full" h="full" px={6}>
      <Stack w="full" h="full" spacing={4}>
        <Box fontWeight={600} w="full">
          {label}
        </Box>
        <Center flex={1} h="full">
          {isLoading ? <CustomSpinner /> : content}
        </Center>
      </Stack>
    </BorderedBox>
  );
};
